








































import { Component, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Tipologiaservizio } from '@/data/models/tipologiaservizio.model';

@Component
export default class TipologiainterventoFilter extends Vue {

	advancedSearch: Search;

	searchParam: any = new class {
		name: string = '';
		type: string | null = null;
	};

	tipoServizioClass: ClassType<Tipologiaservizio> = Tipologiaservizio;
	tipoServizioValue: string = 'id';
	tipoServizioLabel: string = 'name';

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('intervento');
	}

	search() {
		this.advancedSearch.reset();

		if (this.searchParam.name) this.advancedSearch.addLikeFilter('name', this.searchParam.name);
		if (this.searchParam.type) this.advancedSearch.addSimpleFilter('tipologiaservizioid', this.searchParam.type);

		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.name = '';
		this.searchParam.type = null;
		this.search();
	}

}
